<template>

  <t-page>

    <t-page-form card :submit-text="currentPage.singularTitle"
                 :title="t('form-of')+currentPage.pageTitle"
                 :command="command" :status="status" :generalErrors="generalErrors" @onSubmit="onSubmit"
                 :check-errors-again="checkErrorsComponent"
                 :go-back-title="t('go-back-list')" :go-back-path="currentPage.path+'/param'" :busy="!pageFormIsLoaded">

      <template #default="{status}">

        <t-input v-model="form.settingId" hidden/>

        <t-input v-model="form.typeGroupSettingName" fixed label="Parâmetro"/>

        <t-input v-model="form.typeGroupSettingGrouping" fixed label="Grupo"/>

        <b-row v-show="pageFormIsLoaded" class="fadeIn" cols="12">


          <t-field-customized v-for="(item,index) in localParamFields" :key="index"
                              :field="item" v-model="item.value"
                              :command="command" :status="status"/>
        </b-row>

        <t-input v-model="form.note" fixed label="Observações" textarea/>

        <b-row v-if="objValid(form.logControl) && objValid(form.logControl.updatedDate)">
          <t-input v-model="form.logControl.updatedDate" datetime label="Data Modificado" cols="6" fixed/>
          <t-input v-model="form.logControl.updatedUser" label="Responsável" cols="6" fixed/>
        </b-row>

      </template>


    </t-page-form>

  </t-page>

</template>

<script>

import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import SettingValidationType from "@/model/types/modules/general/SettingValidationType";
import tFieldCustomized from "@/components/template/form/input/t-field-customized";
import VarType from "@/model/types/resource/VarType";
import pageParamMixin from "@/mixins/page/pageParamMixin";
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageParamMixin],
  components: {tFieldCustomized},
  name: 'ParamForm',
  data() {
    return {
      path: "", //Utilizar somente quando fora do padrão
      genKey: false, //Utilizar quando desejar gerar chave temporária
      fieldKey: "settingId",
      form: {
        settingId: 0,
        settingNumber: 0,
        pageId: 0,
        typeGroupSettingId: 0,
        field1_dateValue: "",
        field1_doubleValue: 0.0,
        field1_integerValue: 0,
        field1_stringValue: "",
        field2_dateValue: "",
        field2_doubleValue: 0.0,
        field2_integerValue: 0,
        field2_stringValue: "",
        field3_dateValue: "",
        field3_doubleValue: 0.0,
        field3_integerValue: 0,
        field3_stringValue: "",
        field4_dateValue: "",
        field4_doubleValue: 0.0,
        field4_integerValue: 0,
        field4_stringValue: "",
        field5_dateValue: "",
        field5_doubleValue: 0.0,
        field5_integerValue: 0,
        field5_stringValue: "",
        typeGroupSettingName: "",
        typeGroupSettingGrouping: "",
        status: 1
      },
      error: {//Campos que podem receber retorno de erro do backend
        name: ""
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      localParamFields: []
      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    module: {
      type: String,
      required: true,
    },
  },
  methods: {

    mountedPrepare() {

      this.path = this.module + "/setting"

      this.userAuth.currentPage.path = this.path + "/param"


    },
    async mountedContinued() {

      this.validationCommentOption = this.getRenderRule('validationSettingParamOption')

      if (this.relationAccessSubValidation('sub-general-setting-param')) {

        if (this.validationCommentOption >= SettingValidationType.type.ONLY_VIEW)
          this.userAuth.validation.validationRead = true


        if (this.validationCommentOption >= SettingValidationType.type.INSERT_OR_UPDATE)
          this.userAuth.validation.validationUpdate = true

      }

      this.setValidationDefault(this.userAuth.validation)


      this.pageFormIsLoaded = true
      this.setIsLoadingPage(false)

      let paramFields = []


      //Por enquanto somente 1 campo habilitado
      paramFields.push(ui.getParamFieldByPosition(this.form, 1))

      if (this.form['field2'] !== undefined)
        paramFields.push(ui.getParamFieldByPosition(this.form, 2))

      if (this.form['field3'] !== undefined)
        paramFields.push(ui.getParamFieldByPosition(this.form, 3))

      if (this.form['field4'] !== undefined)
        paramFields.push(ui.getParamFieldByPosition(this.form, 4))

      if (this.form['field5'] !== undefined)
        paramFields.push(ui.getParamFieldByPosition(this.form, 5))


      this.localParamFields = paramFields

      let index = 1;

      for (let field of this.localParamFields) {


        let nameField;

        if (field.var === VarType.type.BOOLEAN || field.var === VarType.type.INTEGER) {

          nameField = "integerValue"

        } else if (field.var === VarType.type.DOUBLE) {

          nameField = "doubleValue"

        } else if (field.var === VarType.type.STRING) {

          nameField = "stringValue"

        } else if (field.var === VarType.type.DATE) {

          nameField = "dateValue"

        }

        // pega valor bruto
        let rawValue = this.form["field" + index]?.[nameField]

        // aplica fallback por tipo
        if (rawValue === null || rawValue === undefined) {

          if (field.var === VarType.type.BOOLEAN) {
            field.value = false

          } else if (field.var === VarType.type.INTEGER) {
            field.value = 0

          } else if (field.var === VarType.type.DOUBLE) {
            field.value = 0

          } else if (field.var === VarType.type.STRING) {
            field.value = ""

          } else if (field.var === VarType.type.DATE) {
            field.value = ""

          }

        } else {
          field.value = rawValue
        }

        index++;

      }

    },
    async onSubmit() {

      let index = 1;

      for (let field of this.localParamFields) {

        let nameField;

        if (field.var === VarType.type.BOOLEAN) {

          nameField = "integerValue"

        } else if (field.var === VarType.type.INTEGER) {

          nameField = "integerValue"

        } else if (field.var === VarType.type.DOUBLE) {

          nameField = "doubleValue"

        } else if (field.var === VarType.type.STRING) {

          nameField = "stringValue"


        } else if (field.var === VarType.type.DATE) {

          nameField = "dateValue"

        }

        this.form["field" + index][nameField] = field.value
        index++;

      }

      await this.setSending(
          this.form.settingId,
          (response) => {
            this.setRedirect(this.path + "/param", response[this.fieldKey], this.command, 0, "", true)
          })

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedForm(false, true, false)

    await this.mountedContinued()

  },

}
</script>
